import React, { useState } from 'react';
import PropTypes from 'prop-types';

const Instructions = ({ currentUser }) => {
  const [showInstructions, setShowInstructions] = useState(false);

  const toggleInstructions = () => {
    setShowInstructions(!showInstructions);
  };

  return (
    <>
      {/* Help button */}
      <button
        onClick={toggleInstructions}
        className="absolute bottom-4 right-4 bg-white bg-opacity-90 p-2 rounded-full shadow-md hover:bg-opacity-100 transition-all z-10"
        aria-label="Show instructions"
      >
        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-indigo-700" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
      </button>

      {/* Instructions panel */}
      {showInstructions && (
        <div className="absolute top-0 left-0 w-full h-full bg-black bg-opacity-70 flex items-center justify-center z-20">
          <div className="bg-white rounded-xl p-6 max-w-md shadow-2xl">
            <h2 className="text-2xl font-bold text-indigo-800 mb-4">How to Play</h2>

            <div className="space-y-4 text-gray-700">
              <div>
                <h3 className="font-bold text-lg text-indigo-700">Movement</h3>
                <p>Use the arrow keys or WASD to move your character around the world.</p>
              </div>

              <div>
                <h3 className="font-bold text-lg text-indigo-700">Learning Modules</h3>
                <p>Move close to a learning module and press Enter to explore that feature.</p>
              </div>

              {currentUser ? (
                <>
                  <div>
                    <h3 className="font-bold text-lg text-indigo-700">Collect Gems</h3>
                    <p>Collect the sparkling gems to earn coin multipliers:</p>
                    <ul className="list-disc pl-5 mt-2">
                      <li>Every 10 gems = 2x coin multiplier</li>
                      <li>Every 20 gems = 3x coin multiplier</li>
                      <li>Every 30 gems = 4x coin multiplier</li>
                      <li>And so on!</li>
                    </ul>
                    <p className="mt-2">Start a chat with gems collected to boost your coin rewards!</p>
                  </div>

                  <div>
                    <h3 className="font-bold text-lg text-indigo-700">Watch Out!</h3>
                    <p>Avoid the colored enemies. If they catch you, you'll lose all your collected gems!</p>
                  </div>
                </>
              ) : (
                <>
                  <div>
                    <h3 className="font-bold text-lg text-indigo-700">Collect Gems</h3>
                    <p>Collect the sparkling gems to earn points and compete for a high score!</p>
                  </div>

                  <div>
                    <h3 className="font-bold text-lg text-indigo-700">Watch Out!</h3>
                    <p>Avoid the colored enemies. If they catch you, you'll lose all your collected gems!</p>
                  </div>

                  <div>
                    <h3 className="font-bold text-lg text-indigo-700">Sign Up for More!</h3>
                    <p>Create an account to unlock all learning features and save your progress!</p>
                  </div>
                </>
              )}
            </div>

            <button
              onClick={toggleInstructions}
              className="mt-6 px-4 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 transition-colors"
            >
              Got it!
            </button>
          </div>
        </div>
      )}
    </>
  );
};

Instructions.propTypes = {
  currentUser: PropTypes.object
};

export default Instructions;